"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputOrderSchema = exports.hasSelfRelatedInputTable = exports.hasOnlyRelatedInputTables = exports.DEFAULT_INPUT_ORDER = exports.compareInputOrder = exports.MAX_BOUNDED_LOOP_ITERATIONS = exports.AutomationSafetyDiagnosticPageSchema = exports.AutomationSafetyActionSchema = exports.AutomationLoopDiagnosticSchema = exports.AutomationTerminalReasonSchema = exports.AutomationIncidentStateSchema = exports.AutomationIncidentReasonSchema = exports.LoopPathSegmentSchema = exports.AutomationCausalTransitionSchema = exports.AutomationCausationSchema = exports.AUTOMATION_CAUSATION_MAX_DEPTH = exports.AutomationTriggerOriginSchema = exports.AutomationNodeIdentitySchema = exports.HttpStepConfigSchema = exports.AutomationJsonValueSchema = exports.HttpTargetSchema = exports.AutomationTargetScopeSchema = exports.AutomationActivationModeSchema = exports.AutomationEdgeKindSchema = exports.AutomationResourceTypeSchema = exports.AutomationTopologyVerdictSchema = exports.AUTOMATION_TOPOLOGY_VERDICTS = exports.AUTOMATION_TOPOLOGY_TRANSITIONS = exports.AutomationTopologyStateSchema = exports.AUTOMATION_TOPOLOGY_STATES = void 0;
exports.canTransitionTopology = canTransitionTopology;
exports.topologyStateForVerdict = topologyStateForVerdict;
exports.canonicalAutomationJson = canonicalAutomationJson;
exports.automationSafetyDigest = automationSafetyDigest;
exports.stronglyConnectedComponents = stronglyConnectedComponents;
exports.analyzeWorkflowCycles = analyzeWorkflowCycles;
const zod_1 = require("zod");
__exportStar(require("./batch"), exports);
__exportStar(require("./billing"), exports);
__exportStar(require("./block-defaults"), exports);
__exportStar(require("./input-table-config"), exports);
__exportStar(require("./manual-run"), exports);
__exportStar(require("./output-targets"), exports);
__exportStar(require("./readiness"), exports);
__exportStar(require("./row-match"), exports);
__exportStar(require("./row-window"), exports);
__exportStar(require("./safety-presentation"), exports);
__exportStar(require("./schedule"), exports);
__exportStar(require("./trigger"), exports);
const UuidSchema = zod_1.z.string().uuid();
const DigestSchema = zod_1.z.string().regex(/^[0-9a-f]{64}$/);
const EpochSchema = zod_1.z.string().regex(/^(0|[1-9][0-9]{0,18})$/);
exports.AUTOMATION_TOPOLOGY_STATES = [
    'DRAFT',
    'CANDIDATE_PENDING',
    'SAFE',
    'BLOCKED_CYCLE',
    'EXTERNAL_UNVERIFIABLE',
    'ANALYSIS_FAILED',
];
exports.AutomationTopologyStateSchema = zod_1.z.enum(exports.AUTOMATION_TOPOLOGY_STATES);
exports.AUTOMATION_TOPOLOGY_TRANSITIONS = {
    DRAFT: ['CANDIDATE_PENDING'],
    CANDIDATE_PENDING: [
        'SAFE',
        'BLOCKED_CYCLE',
        'EXTERNAL_UNVERIFIABLE',
        'ANALYSIS_FAILED',
    ],
    SAFE: [],
    BLOCKED_CYCLE: [],
    EXTERNAL_UNVERIFIABLE: [],
    ANALYSIS_FAILED: [],
};
function canTransitionTopology(from, to) {
    return exports.AUTOMATION_TOPOLOGY_TRANSITIONS[from].includes(to);
}
exports.AUTOMATION_TOPOLOGY_VERDICTS = [
    'SAFE',
    'BLOCKED_CYCLE',
    'EXTERNAL_UNVERIFIABLE',
    'ANALYSIS_FAILED',
];
exports.AutomationTopologyVerdictSchema = zod_1.z.enum(exports.AUTOMATION_TOPOLOGY_VERDICTS);
function topologyStateForVerdict(verdict) {
    switch (verdict) {
        case 'SAFE':
        case 'BLOCKED_CYCLE':
        case 'EXTERNAL_UNVERIFIABLE':
        case 'ANALYSIS_FAILED':
            return verdict;
        default: {
            const exhaustive = verdict;
            return exhaustive;
        }
    }
}
exports.AutomationResourceTypeSchema = zod_1.z.enum([
    'automation_config',
    'workflow_snapshot',
    'database',
    'document',
    'schedule',
    'webhook_binding',
    'credential',
    'external_origin',
    'mailbox',
]);
exports.AutomationEdgeKindSchema = zod_1.z.enum([
    'reads',
    'writes',
    'activates',
    'scheduled_root',
    'bounded_loop',
    'external_unknown',
]);
exports.AutomationActivationModeSchema = zod_1.z.enum([
    'manual',
    'scheduled',
    'row_created',
    'row_changed',
    'webhook',
    'app_base',
    'resume',
]);
exports.AutomationTargetScopeSchema = zod_1.z.enum([
    'same_workspace',
    'cross_workspace',
    'cross_tenant',
    'external',
]);
const HttpOriginSchema = zod_1.z
    .string()
    .url()
    .superRefine((value, ctx) => {
    const url = new URL(value);
    if (!['http:', 'https:'].includes(url.protocol) || value !== url.origin) {
        ctx.addIssue({ code: 'custom', message: 'HTTP_ORIGIN_REQUIRED' });
    }
});
const ExternalOriginPolicySchema = zod_1.z
    .object({
    // Empty means preview-only. Any activated or normal manual execution
    // fails closed in the runner until at least one origin is declared.
    origins: zod_1.z.array(HttpOriginSchema).max(32),
    policyVersion: zod_1.z.string().min(1).max(64),
})
    .strict();
exports.HttpTargetSchema = zod_1.z.discriminatedUnion('kind', [
    zod_1.z
        .object({
        kind: zod_1.z.literal('external'),
        urlTemplate: zod_1.z.string().min(1).max(8192),
        originPolicy: ExternalOriginPolicySchema,
    })
        .strict(),
    zod_1.z
        .object({
        kind: zod_1.z.literal('internalWebhook'),
        credentialRef: zod_1.z.string().min(1).max(128),
        targetWorkspaceId: UuidSchema,
        targetBindingId: UuidSchema,
        targetEpoch: EpochSchema,
    })
        .strict(),
]);
exports.AutomationJsonValueSchema = zod_1.z.lazy(() => zod_1.z.union([
    zod_1.z.null(),
    zod_1.z.boolean(),
    zod_1.z.number(),
    zod_1.z.string(),
    zod_1.z.array(exports.AutomationJsonValueSchema),
    zod_1.z.record(zod_1.z.string(), exports.AutomationJsonValueSchema),
]));
exports.HttpStepConfigSchema = zod_1.z
    .object({
    type: zod_1.z.literal('http'),
    target: exports.HttpTargetSchema,
    method: zod_1.z.enum(['GET', 'POST', 'PUT', 'PATCH', 'DELETE']),
    headers: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).optional(),
    bodyTemplate: exports.AutomationJsonValueSchema.optional(),
    responseExtract: zod_1.z.string().max(4096).optional(),
    timeoutMs: zod_1.z.number().int().positive().max(1_200_000).optional(),
    response: zod_1.z
        .object({ expectBinary: zod_1.z.boolean().optional() })
        .strict()
        .optional(),
    // Editor keys the workflow graph writes into every HTTP step: the catalog
    // node identity, the dynamic variable lists (JSON text) and the template a
    // published node belongs to (workflow-editor.controller publish-node).
    nodeTypeSlug: zod_1.z.string().min(1).max(128).optional(),
    __managedTemplateId: zod_1.z.string().min(1).max(128).optional(),
    inputVariables: zod_1.z.string().max(65_536).optional(),
    outputVariables: zod_1.z.string().max(65_536).optional(),
})
    .strict();
exports.AutomationNodeIdentitySchema = zod_1.z
    .object({
    workspaceId: UuidSchema,
    configId: zod_1.z.string().min(1).max(128),
    candidateDigest: DigestSchema,
    activationEpoch: EpochSchema,
})
    .strict();
/**
 * Secret-free, queue-safe evidence of who started a run and through which
 * app action. It travels with the webhook admission and the causation, so
 * the executing worker can revalidate the live app policy before capacity,
 * binding and dispatch.
 */
exports.AutomationTriggerOriginSchema = zod_1.z.discriminatedUnion('kind', [
    zod_1.z
        .object({
        kind: zod_1.z.literal('app_base'),
        appBaseId: zod_1.z.string().min(1).max(128),
        manifestId: zod_1.z.string().min(1).max(128),
        routePath: zod_1.z.string().min(1).max(512),
        actionId: zod_1.z.string().min(1).max(128),
        actionRevision: zod_1.z.string().regex(/^(0|[1-9][0-9]{0,18})$/),
        actionDigest: DigestSchema,
        actionAudience: zod_1.z.enum(['public', 'portal', 'members', 'internal']),
        blockId: zod_1.z.string().min(1).max(128),
        workflowId: zod_1.z.string().min(1).max(255),
        exposure: zod_1.z.enum(['publicInteractive', 'memberPortal', 'internalLive']),
        effectivePrincipalType: zod_1.z.enum([
            'anonymous',
            'portal',
            'workspaceMember',
        ]),
        principalId: zod_1.z.string().min(1).max(128),
        policyRevision: zod_1.z.string().min(1).max(64),
        admissionDecisionId: DigestSchema,
        admissionFingerprint: DigestSchema,
    })
        .strict(),
    zod_1.z
        .object({
        kind: zod_1.z.literal('form_submission'),
        appBaseId: zod_1.z.string().min(1).max(128),
        submissionId: zod_1.z.string().min(1).max(128),
        workflowId: zod_1.z.string().min(1).max(255),
        configId: zod_1.z.string().min(1).max(128),
        credentialId: zod_1.z.string().min(1).max(128),
        triggerEpoch: EpochSchema,
        formPolicyDigest: DigestSchema,
    })
        .strict(),
]);
/** The most automations one chain of runs passes through; a longer chain is refused. */
exports.AUTOMATION_CAUSATION_MAX_DEPTH = 32;
exports.AutomationCausationSchema = zod_1.z
    .object({
    version: zod_1.z.literal(1),
    rootExecutionId: UuidSchema,
    parentExecutionId: UuidSchema.nullable(),
    sourceExecutionId: UuidSchema.nullable(),
    triggerKind: exports.AutomationActivationModeSchema,
    current: exports.AutomationNodeIdentitySchema,
    ancestry: zod_1.z
        .array(exports.AutomationNodeIdentitySchema)
        .max(exports.AUTOMATION_CAUSATION_MAX_DEPTH),
    depth: zod_1.z.number().int().min(0).max(exports.AUTOMATION_CAUSATION_MAX_DEPTH),
    pathDigest: DigestSchema,
    invocationOrdinal: zod_1.z.number().int().min(0),
    fanoutOrdinal: zod_1.z.number().int().min(0),
    targetBindingId: zod_1.z.string().min(1).max(128).nullable(),
    invocationKey: zod_1.z.string().min(1).max(256),
    triggerOrigin: exports.AutomationTriggerOriginSchema.optional(),
})
    .strict()
    .superRefine((value, ctx) => {
    if (value.depth !== value.ancestry.length) {
        ctx.addIssue({ code: 'custom', message: 'CAUSATION_DEPTH_MISMATCH' });
    }
    if (value.depth === 0 && value.parentExecutionId !== null) {
        ctx.addIssue({ code: 'custom', message: 'ROOT_HAS_PARENT' });
    }
    if (value.depth > 0 && value.parentExecutionId === null) {
        ctx.addIssue({ code: 'custom', message: 'NON_ROOT_REQUIRES_PARENT' });
    }
    if (value.depth === 0 && value.sourceExecutionId !== null) {
        ctx.addIssue({ code: 'custom', message: 'ROOT_HAS_SOURCE_EXECUTION' });
    }
    if (value.depth > 0 && value.sourceExecutionId === null) {
        ctx.addIssue({
            code: 'custom',
            message: 'NON_ROOT_REQUIRES_SOURCE_EXECUTION',
        });
    }
});
exports.AutomationCausalTransitionSchema = zod_1.z
    .object({
    version: zod_1.z.literal(1),
    source: exports.AutomationNodeIdentitySchema,
    target: exports.AutomationNodeIdentitySchema,
    boundaryCapabilityId: UuidSchema.nullable(),
    boundaryCapabilityEpoch: EpochSchema.nullable(),
    invocationKey: zod_1.z.string().min(1).max(256),
})
    .strict();
exports.LoopPathSegmentSchema = zod_1.z
    .object({
    opaque: zod_1.z.boolean(),
    resourceType: exports.AutomationResourceTypeSchema,
    edgeKind: exports.AutomationEdgeKindSchema,
    workspaceId: UuidSchema.optional(),
    configId: zod_1.z.string().min(1).max(128).optional(),
    stepId: zod_1.z.string().min(1).max(128).optional(),
    displayName: zod_1.z.string().min(1).max(256).optional(),
    /** The doc and block a visible step opens (automation block or table). */
    docId: zod_1.z.string().min(1).max(128).optional(),
    blockId: zod_1.z.string().min(1).max(128).optional(),
})
    .strict()
    .superRefine((value, ctx) => {
    if (value.opaque &&
        (value.workspaceId ||
            value.configId ||
            value.stepId ||
            value.displayName ||
            value.docId ||
            value.blockId)) {
        ctx.addIssue({ code: 'custom', message: 'OPAQUE_SEGMENT_LEAK' });
    }
});
exports.AutomationIncidentReasonSchema = zod_1.z.enum([
    'static_cycle',
    'runtime_cycle',
    'depth_exceeded',
    'suspected_external_loop',
    'stale_topology',
]);
exports.AutomationIncidentStateSchema = zod_1.z.enum([
    'open',
    'binding_paused',
    'resolved',
]);
exports.AutomationTerminalReasonSchema = zod_1.z.enum([
    'cycle_blocked',
    'suspected_external_loop',
    'mail_reply_loop',
    'import_flood',
]);
exports.AutomationLoopDiagnosticSchema = zod_1.z
    .object({
    incidentId: UuidSchema,
    reason: exports.AutomationIncidentReasonSchema,
    state: exports.AutomationIncidentStateSchema,
    path: zod_1.z.array(exports.LoopPathSegmentSchema).max(64),
    createdAt: zod_1.z.string().datetime(),
    resolvedAt: zod_1.z.string().datetime().nullable(),
})
    .strict();
exports.AutomationSafetyActionSchema = zod_1.z.enum([
    'save_draft',
    'reanalyze',
    'declare_external_origin',
    'resolve_incident',
    'enable',
]);
exports.AutomationSafetyDiagnosticPageSchema = zod_1.z
    .object({
    subject: zod_1.z
        .object({
        workflowId: zod_1.z.string().min(1).max(128),
        configId: zod_1.z.string().min(1).max(128),
    })
        .strict(),
    topology: zod_1.z
        .object({
        state: exports.AutomationTopologyStateSchema,
        candidateDigest: DigestSchema.nullable(),
        analysisReason: zod_1.z.string().max(64).nullable(),
        analyzedAt: zod_1.z.string().datetime().nullable(),
    })
        .strict(),
    actions: zod_1.z.array(exports.AutomationSafetyActionSchema),
    incidents: zod_1.z.array(exports.AutomationLoopDiagnosticSchema).max(50),
    nextCursor: UuidSchema.nullable(),
})
    .strict();
function canonicalAutomationJson(value) {
    if (value === null ||
        typeof value === 'boolean' ||
        typeof value === 'string') {
        return JSON.stringify(value);
    }
    if (typeof value === 'number') {
        if (!Number.isFinite(value))
            throw new Error('CANONICAL_JSON_NON_FINITE');
        return JSON.stringify(value);
    }
    if (Array.isArray(value)) {
        return `[${value.map(canonicalAutomationJson).join(',')}]`;
    }
    if (typeof value === 'object') {
        return `{${Object.entries(value)
            .sort(([left], [right]) => (left < right ? -1 : left > right ? 1 : 0))
            .map(([key, entry]) => `${JSON.stringify(key)}:${canonicalAutomationJson(entry)}`)
            .join(',')}}`;
    }
    throw new Error('CANONICAL_JSON_UNSUPPORTED');
}
async function automationSafetyDigest(value) {
    const bytes = new TextEncoder().encode(canonicalAutomationJson(value));
    const digest = await globalThis.crypto.subtle.digest('SHA-256', bytes);
    return Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('');
}
exports.MAX_BOUNDED_LOOP_ITERATIONS = 10_000;
const byBytes = (left, right) => left < right ? -1 : left > right ? 1 : 0;
/**
 * Single deterministic, iterative SCC implementation for workflow and
 * topology graphs. Kosaraju's two bounded passes avoid call-stack exhaustion
 * at the 10k-node topology limit while retaining O(V + E) traversal.
 */
function stronglyConnectedComponents(rawNodes, rawEdges) {
    const nodes = [...new Set(rawNodes)].sort(byBytes);
    const nodeSet = new Set(nodes);
    const outgoing = new Map(nodes.map(node => [node, []]));
    const incoming = new Map(nodes.map(node => [node, []]));
    for (const edge of rawEdges) {
        if (nodeSet.has(edge.source) && nodeSet.has(edge.target)) {
            outgoing.get(edge.source).push(edge.target);
            incoming.get(edge.target).push(edge.source);
        }
    }
    for (const targets of outgoing.values())
        targets.sort(byBytes);
    for (const sources of incoming.values())
        sources.sort(byBytes);
    const visited = new Set();
    const finishOrder = [];
    for (const start of nodes) {
        if (visited.has(start))
            continue;
        visited.add(start);
        const stack = [{ node: start, nextTarget: 0 }];
        while (stack.length) {
            const frame = stack[stack.length - 1];
            const targets = outgoing.get(frame.node);
            const target = targets[frame.nextTarget];
            if (target !== undefined) {
                frame.nextTarget += 1;
                if (!visited.has(target)) {
                    visited.add(target);
                    stack.push({ node: target, nextTarget: 0 });
                }
                continue;
            }
            finishOrder.push(frame.node);
            stack.pop();
        }
    }
    const assigned = new Set();
    const components = [];
    for (let index = finishOrder.length - 1; index >= 0; index -= 1) {
        const start = finishOrder[index];
        if (assigned.has(start))
            continue;
        const component = [];
        const stack = [start];
        assigned.add(start);
        while (stack.length) {
            const node = stack.pop();
            component.push(node);
            const sources = incoming.get(node);
            for (let sourceIndex = sources.length - 1; sourceIndex >= 0; sourceIndex -= 1) {
                const source = sources[sourceIndex];
                if (!assigned.has(source)) {
                    assigned.add(source);
                    stack.push(source);
                }
            }
        }
        components.push(component.sort(byBytes));
    }
    return components.sort((left, right) => byBytes(left.join('\u0000'), right.join('\u0000')));
}
/**
 * Pure cycle-validation source of truth shared by API preflight and runner.
 * A cyclic SCC is valid only when removing the edges that close into its
 * single explicit loop node makes the component acyclic. Thus arbitrary
 * graph cycles can never be silently reclassified as executable loops.
 */
function analyzeWorkflowCycles(rawSteps, rawEdges) {
    const steps = [...rawSteps].sort((a, b) => byBytes(a.id, b.id));
    const stepById = new Map(steps.map(step => [step.id, step]));
    const edges = rawEdges
        .filter(edge => stepById.has(edge.sourceStepId) && stepById.has(edge.targetStepId))
        .sort((a, b) => byBytes(`${a.sourceStepId}\u0000${a.targetStepId}\u0000${a.id}`, `${b.sourceStepId}\u0000${b.targetStepId}\u0000${b.id}`));
    const outgoing = new Map();
    for (const step of steps)
        outgoing.set(step.id, []);
    for (const edge of edges)
        outgoing.get(edge.sourceStepId).push(edge);
    const components = stronglyConnectedComponents(steps.map(step => step.id), edges.map(edge => ({
        source: edge.sourceStepId,
        target: edge.targetStepId,
    })));
    const errors = [];
    const backEdgeIds = new Set();
    for (const component of components) {
        const members = new Set(component);
        const internalEdges = edges.filter(edge => members.has(edge.sourceStepId) && members.has(edge.targetStepId));
        const cyclic = component.length > 1 ||
            internalEdges.some(edge => edge.sourceStepId === edge.targetStepId);
        if (!cyclic)
            continue;
        const loopNodes = component.filter(id => stepById.get(id)?.type === 'loop');
        const referenceId = loopNodes[0] ?? component[0];
        const path = canonicalCyclePath(component, internalEdges);
        if (loopNodes.length !== 1) {
            errors.push({ code: 'UNBOUNDED_GRAPH_CYCLE', referenceId, path });
            continue;
        }
        const loopId = loopNodes[0];
        const loop = stepById.get(loopId);
        const maxIterations = loop.config?.['maxIterations'];
        if (!Number.isInteger(maxIterations) || Number(maxIterations) <= 0) {
            errors.push({
                code: 'LOOP_MAX_ITERATIONS_REQUIRED',
                referenceId: loopId,
                path,
            });
        }
        else if (Number(maxIterations) > exports.MAX_BOUNDED_LOOP_ITERATIONS) {
            errors.push({
                code: 'LOOP_MAX_ITERATIONS_EXCEEDED',
                referenceId: loopId,
                path,
            });
        }
        const loopOutgoing = outgoing.get(loopId) ?? [];
        if (!loopOutgoing.some(edge => edge.sourcePort === 'continue')) {
            errors.push({ code: 'LOOP_MISSING_CONTINUE', referenceId: loopId, path });
        }
        if (!loopOutgoing.some(edge => edge.sourcePort === 'exit')) {
            errors.push({ code: 'LOOP_MISSING_EXIT', referenceId: loopId, path });
        }
        const closers = internalEdges.filter(edge => edge.targetStepId === loopId);
        if (!closers.length ||
            hasCycle(component, internalEdges, new Set(closers.map(e => e.id)))) {
            errors.push({
                code: 'LOOP_CYCLE_STRUCTURE_INVALID',
                referenceId: loopId,
                path,
            });
            continue;
        }
        for (const edge of closers)
            backEdgeIds.add(edge.id);
    }
    return {
        valid: errors.length === 0,
        errors,
        backEdgeIds,
        executionOrder: topologicalOrder(steps, edges, backEdgeIds),
    };
}
function hasCycle(nodes, edges, excluded) {
    const indegree = new Map(nodes.map(id => [id, 0]));
    for (const edge of edges) {
        if (!excluded.has(edge.id)) {
            indegree.set(edge.targetStepId, (indegree.get(edge.targetStepId) ?? 0) + 1);
        }
    }
    const queue = nodes.filter(id => indegree.get(id) === 0).sort(byBytes);
    let visited = 0;
    while (queue.length) {
        const current = queue.shift();
        visited += 1;
        for (const edge of edges) {
            if (excluded.has(edge.id) || edge.sourceStepId !== current)
                continue;
            const next = (indegree.get(edge.targetStepId) ?? 0) - 1;
            indegree.set(edge.targetStepId, next);
            if (next === 0) {
                queue.push(edge.targetStepId);
                queue.sort(byBytes);
            }
        }
    }
    return visited !== nodes.length;
}
function topologicalOrder(steps, edges, excluded) {
    const ids = steps.map(step => step.id);
    const indegree = new Map(ids.map(id => [id, 0]));
    for (const edge of edges) {
        if (!excluded.has(edge.id)) {
            indegree.set(edge.targetStepId, (indegree.get(edge.targetStepId) ?? 0) + 1);
        }
    }
    const queue = ids.filter(id => indegree.get(id) === 0).sort(byBytes);
    const result = [];
    while (queue.length) {
        const current = queue.shift();
        result.push(current);
        for (const edge of edges) {
            if (excluded.has(edge.id) || edge.sourceStepId !== current)
                continue;
            const next = (indegree.get(edge.targetStepId) ?? 0) - 1;
            indegree.set(edge.targetStepId, next);
            if (next === 0) {
                queue.push(edge.targetStepId);
                queue.sort(byBytes);
            }
        }
    }
    return result.length === ids.length ? result : ids.sort(byBytes);
}
function canonicalCyclePath(component, edges) {
    const start = component[0];
    const path = [start];
    const visited = new Set([start]);
    let current = start;
    for (let i = 0; i <= component.length; i += 1) {
        const next = edges
            .filter(edge => edge.sourceStepId === current)
            .sort((a, b) => byBytes(`${a.targetStepId}\u0000${a.id}`, `${b.targetStepId}\u0000${b.id}`))[0];
        if (!next)
            break;
        path.push(next.targetStepId);
        if (next.targetStepId === start)
            break;
        if (visited.has(next.targetStepId))
            break;
        visited.add(next.targetStepId);
        current = next.targetStepId;
    }
    return path.slice(0, 64);
}
var input_1 = require("./input");
Object.defineProperty(exports, "compareInputOrder", { enumerable: true, get: function () { return input_1.compareInputOrder; } });
Object.defineProperty(exports, "DEFAULT_INPUT_ORDER", { enumerable: true, get: function () { return input_1.DEFAULT_INPUT_ORDER; } });
Object.defineProperty(exports, "hasOnlyRelatedInputTables", { enumerable: true, get: function () { return input_1.hasOnlyRelatedInputTables; } });
Object.defineProperty(exports, "hasSelfRelatedInputTable", { enumerable: true, get: function () { return input_1.hasSelfRelatedInputTable; } });
Object.defineProperty(exports, "InputOrderSchema", { enumerable: true, get: function () { return input_1.InputOrderSchema; } });
//# sourceMappingURL=index.js.map